import { Swiper } from 'swiper';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

class Gallery {
  private swiperElements: NodeListOf<HTMLElement>;
  private swiperInstances = new Map<HTMLElement, Swiper>();

  private gridElements: NodeListOf<HTMLElement>;
  private masonryInstances = new Map<HTMLElement, Masonry>();


  private readonly breakpoint = 1025;
  private resizeTimer: number | null = null;

  constructor() {
    this.swiperElements = document.querySelectorAll<HTMLElement>('[data-gallery-swiper]');
    this.gridElements = document.querySelectorAll<HTMLElement>('[data-gallery-masonry]');
    this._init();
  }

  private _init() {

    window.addEventListener('resize', () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = window.setTimeout(() => {
        this.toggleMasonryState();
        this.toggleSwiperState();
      }, 250);
    });

    this.toggleMasonryState();
    this.toggleSwiperState();

  }

  private toggleMasonryState(): void {
    const isMobile = window.innerWidth < this.breakpoint;

    this.gridElements.forEach(grid => {
      const isInitialized = this.masonryInstances.has(grid);

      if (isMobile && !isInitialized) {
        imagesLoaded(grid, () => {
          const msnry = new Masonry(grid, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            gutter: 8
          });
          this.masonryInstances.set(grid, msnry);
        });
      }
      else if (!isMobile && isInitialized) {
        const msnryInstance = this.masonryInstances.get(grid);
        msnryInstance?.destroy();
        this.masonryInstances.delete(grid);
      }
    });
  }

  private toggleSwiperState(): void {
    const isMobile = window.innerWidth < this.breakpoint;

    this.swiperElements.forEach(swiperEl => {
      const isInitialized = this.swiperInstances.has(swiperEl);

      if (isMobile && !isInitialized) {
        const instance = new Swiper(swiperEl, {
          direction: 'horizontal',
          slidesPerView: 1.5,
          spaceBetween: 8,
        });
        this.swiperInstances.set(swiperEl, instance);
      }
      else if (!isMobile && isInitialized) {
        const instance = this.swiperInstances.get(swiperEl);
        instance?.destroy();
        this.swiperInstances.delete(swiperEl);
      }
    });
  }
}

export const gallery = new Gallery();
